module.exports = __webpack_public_path__ + "static/media/icon_checkin_orange.e187e603.svg";